export const getFileExt = (filename?: string) =>
  filename ? filename.split('.').slice(-1)[0].toLowerCase() : null;

export const fileIsImg = (filename?: string) => {
  const IMG_EXT = ['gif', 'ico', 'png', 'jpg', 'jpeg'] as const;
  const ext = getFileExt(filename);
  return IMG_EXT.includes(ext as (typeof IMG_EXT)[number]);
};

// IconDocument - extensions doc, pages, pdf, txt
const DOCUMENTS_MIME_TYPES = [
  'application/msword',
  'application/pdf',
  'text/plain'
] as const;

// IconPresentation - extensions ppt, pptx
const PRESENTATIONS_MIME_TYPES = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
] as const;

// IconDocumentGraph - extensions csv, xls, numbers
const SPREADSHEETS_MIME_TYPES = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
] as const;

// IconImage - extensions jpg, png, gif
const IMAGES_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif'] as const;

/**
 * @function getFileIconStr - match the mimetype or file extension with an icon string
 * @returns the icon name to use to represent this file
 */
export const getFileIconStr = (
  mimetype?: string,
  fileName?: string,
  defaultIcon?: string
): string => {
  switch (true) {
    case DOCUMENTS_MIME_TYPES.includes(mimetype as any):
    case getFileExt(fileName) === 'pages':
      return 'Doc';

    case PRESENTATIONS_MIME_TYPES.includes(mimetype as any):
      return 'Presentation';

    case SPREADSHEETS_MIME_TYPES.includes(mimetype as any):
    case getFileExt(fileName) === 'numbers':
      return 'DocGraph';

    case IMAGES_MIME_TYPES.includes(mimetype as any):
      return 'Picture';

    default:
      return defaultIcon || 'DocEmpty';
  }
};
